<template>
  <div class="nb container-fluid">
    <nav class="navbar navbar-expand-lg navbar-dark bg-dark nav-fill" >
      <div class="contaaa h-full">
        <div class="w-100 nav-holder">
          <a class="navbar-brand" href="/" onclick="window.location.reload();return false">
            <img class="logo" width="120" src="//prepclass.com.ng/img/logo.png">
          </a>
          <div class="steps hide-on-small-only">
            <div class="steps-nav">
              <!-- <div class="steps-nav--item" ref="welcome" :class="{ active: ac([ 'welcome' ]) }">
                <p>1</p>
                <span><router-link :to="{ name: 'welcome-setup' }">Welcome</router-link></span>
              </div> -->
              <div class="steps-nav--item" ref="basic" :class="{ active: ac([ 'basic' ]) }">
                <p>1</p>
                <span><router-link :to="{ name: 'basic-setup' }">Personal Information</router-link></span>
              </div>
              <div class="steps-nav--item" ref="education" :class="{ active: ac([ 'education' ]) }">
                <p>2</p>
                <span><router-link :to="{ name: 'education-setup' }" :class="{ disabled: !(u.steps && u.steps.personal_info) }">Educational Background</router-link></span>
              </div>
              <div class="steps-nav--item" ref="verification" :class="{ active: ac([ 'verification' ]) }">
                <p>3</p>
                <span><router-link :to="{ name: 'verification-setup' }" :class="{ disabled: !(u.steps && u.steps.educational_background) }">Verification</router-link></span>
              </div>
              <div class="steps-nav--item" ref="academic_info" :class="{ active: ac([ 'tutoring-info' ]) }">
                <p>4</p>
                <span><router-link :to="{ name: 'availability-info' }" :class="{ disabled: !((u.steps && u.steps.verification) && u.verified) }">Tutoring Information</router-link></span>
              </div>
              <div class="steps-nav--item" ref="how_it_works" :class="{ active: ac([ 'how-it-works' ]) }">
                <p>5</p>
                <span><router-link :to="{ name: 'how-it-works-setup' }" :class="{ disabled: !(u.steps && u.steps.academic_info) }">How it Works</router-link></span>
              </div>
            </div>
          </div>
          <div class="user--details">
            <p class="hide-on-small-only">Tutor ID: {{ this.$auth.user().former_id }}</p>
            <b-dropdown variant="link" size="lg" no-caret>
              <template slot="button-content">
                <img :src="this.$auth.user().profile_pic || '../../assets/skq.jpg'" alt="">
              </template>
              <b-dropdown-item href="#">Settings</b-dropdown-item>
              <b-dropdown-item href="#" @click.prevent="logout">Logout</b-dropdown-item>
            </b-dropdown>
          </div>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
export default {
  name: 'nav-bar',
  data() {
    return {
      showCloseMenu: false,
    };
  },
  computed: {
    u() {
      return this.$auth.user();
    },
    steps() {
      if (this.u.steps) {
        return Object.values(this.u.steps).filter(v => v).length;
      }
      return 0;
    },
  },
  methods: {
    logout() {
      this.$auth.logout({
        makeRequest: false,
        success: () => {
          this.$router.push({name: 'login'}).catch(err => {});
        },
        error() {
          console.log('error logging out ');
        },
      });
    },
    ac(input) {
      const paths = Array.isArray(input) ? input : [input];
      return paths.some(path => this.$route.path.indexOf(path) >= 0);
    },
    toggleMenu() {
      this.showCloseMenu = true;
    },
    toggleClose() {
      this.showCloseMenu = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.contaaa { padding: 0 25px; width: 100%;}
.hide {display: none !important}
.nb {padding: 0; position: fixed; top: 0; left: 0; z-index: 2000;}
.h-full {height: 100%;}
.hide-on-medium-and-up {display: none;}
.nav-holder {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  .steps {
    width: auto;
    height: 100%;
    .steps-nav {
      width: auto;
      height: 100%;
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      align-items: center;
      .steps-nav--item {
        width: 150px;
        margin: 0 10px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        &.active {
          p {background-color: #639440; color: #ffffff;}
        }
        p {
          margin: 0 15px;
          padding: 5px;
          height: 25px;
          line-height: 25px;
          width: 25px;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
          border: 1px solid #639440;
          border-radius: 100%;
          color: #639440;
        }
        span a {
          color: #818181;
          &:hover {
            color: #639440;
            text-decoration: none;
          }
        }
      }
    }
  }
  .user--details {
    padding: 10px;
    color: #fff;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    font-size: 13px;
    height: 100%;
    width: auto;
    min-width: 210px;
    img {
      width: 50px;
      height: 50px;
      border-radius: 50%;
    }
    p {margin: 0; color: #818181;}
  }
}
@media only screen and (max-width: 600px) {
  .contaaa { padding: 0 5px; width: 100%;}
  nav.nav-fill {width: 100%; padding: 10px !important;}
  .hide-on-small-only { display: none; }
  .hide-on-medium-and-up {display: block;}
  .nav-holder {
    .user--details {
      min-width: 35px;
      padding: 0;
      img {width: 35px; height: 35px;}
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Layout/NavBar.vue